import React from 'react';
import { Link } from 'react-router-dom';
import { serviceList } from '../data/siteContent';

export default function Services() {
  return (
    <div className="bg-gradient-to-b from-primary/10 to-white min-h-screen">
      <section className="max-w-6xl mx-auto py-20 px-6">
        <div className="space-y-4 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">what we do</p>
          <h1 className="text-4xl font-bold text-charcoal">Professional services built for confident, compliant leaders</h1>
          <p className="text-gray-600 text-lg">
            Each service is led by a senior CPA strategist and packaged with documentation so your existing advisors can nod along.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          {serviceList.map((service) => (
            <article key={service.slug} className="rounded-3xl border border-white/60 bg-white/80 p-6 shadow-lg">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-semibold text-charcoal">{service.title}</h2>
                <span className="text-xs font-semibold uppercase tracking-[0.4em] text-primary">{service.slug.replace('-', ' ')}</span>
              </div>
              <p className="mt-4 text-gray-600">{service.summary}</p>
              <ul className="mt-5 space-y-2 text-sm text-gray-700">
                {service.bullets.map((bullet) => (
                  <li key={bullet} className="flex items-start gap-2">
                    <span className="mt-1 h-2 w-2 rounded-full bg-primary" />
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex items-center justify-between text-sm text-gray-500">
                <p>{service.stats}</p>
                <Link to={`/services/${service.slug}`} className="text-primary font-semibold">
                  Learn more →
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-sm text-gray-500">Need a tailored combination?</p>
          <Link
            to="/contact"
            className="mt-3 inline-flex items-center gap-2 rounded-full border border-gray-300 px-5 py-3 text-sm font-semibold text-charcoal hover:bg-white hover:shadow-lg"
          >
            Talk to a strategist
          </Link>
        </div>
      </section>
    </div>
  );
}
